/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import cx from 'classnames';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Namespaces } from '../../../../i18n';
import { SUDataset } from '../../../../types/superuser/dataset/SUDataset';
import { useDatasetStatusLabelStyles } from './DatasetStatusLabel.styles';

type DatasetStatusLabelProps = {
  dataset: SUDataset;
};

export const DatasetStatusLabel = memo<DatasetStatusLabelProps>(props => {
  const { dataset } = props;
  const { t } = useTranslation(Namespaces.Admin);
  const classes = useDatasetStatusLabelStyles();

  if (!dataset.exists) {
    return <div className={cx(classes.statusLabel, classes.notExist)}>{t('datasets.table.labels.not_exist')}</div>;
  } else if (!dataset.visible) {
    return <div className={cx(classes.statusLabel, classes.invisible)}>{t('datasets.table.labels.invisible')}</div>;
  }

  return null;
});
